module.exports = __webpack_public_path__ + "static/weekly-1d0e1c07a13f975d83b72e3ca9ef464b.jpg";